import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useDeleteShopApiKey(shop: { id: string }) {
	return useApiMutation("delete", "/shops/{shopId}/api/keys/{keyId}", {
		invalidate: useInvalidateShop(shop.id),
		mapVariables: (keyId: string) => ({
			params: { path: { shopId: shop.id, keyId } },
		}),
	});
}
